<template>
  <b-row>
    <!-- Heading for first three items -->
    <template v-if="instructions.length > 0">
      <b-col cols="12">
        <h5 class="mb-3">MultiTank</h5>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-for="instruction in [...instructions.slice(0, 4), ...instructions.slice(12,13)]"
             :key="instruction.name">
        <a :href="`/instructions/${encodeURIComponent($t(instruction.link))}`"
            :download="$t(instruction.link)"
            class="d-block mb-3 p-2 border border-danger rounded bg-white file"
        >
          <div class="d-flex align-items-center w-100">
            <b-icon icon="file-earmark-check" font-scale="3" variant="danger"></b-icon>
            <div class="pl-3">
              <p class="mb-1 font-weight-bold">{{ $t(instruction.title) }}</p>
              <p class="mb-0 font-weight-light">{{ $t('instructionsData.description') }}</p>
            </div>
          </div>
        </a>
      </b-col>
    </template>

    <template v-if="instructions.length > 0">
      <b-col cols="12">
        <h5 class="mb-3">{{ $t('instructionsData.block_title_glowice') }}</h5>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-for="instruction in instructions.slice(5, 9)"
             :key="instruction.name">
        <a :href="`/instructions/${encodeURIComponent($t(instruction.link))}`"
           :download="$t(instruction.link)"
           class="d-block mb-3 p-2 border border-danger rounded bg-white file"
        >
          <div class="d-flex align-items-center w-100">
            <b-icon icon="file-earmark-check" font-scale="3" variant="danger"></b-icon>
            <div class="pl-3">
              <p class="mb-1 font-weight-bold">{{ $t(instruction.title) }}</p>
              <p class="mb-0 font-weight-light">{{ $t('instructionsData.description') }}</p>
            </div>
          </div>
        </a>
      </b-col>
    </template>

    <template v-if="instructions.length > 0">
      <b-col cols="12">
        <h5 class="mb-3">FTTH One</h5>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-for="instruction in [...instructions.slice(4, 5), ...instructions.slice(10, 11) ]"
             :key="instruction.name">
        <a :href="`/instructions/${encodeURIComponent($t(instruction.link))}`"
           :download="$t(instruction.link)"
           class="d-block mb-3 p-2 border border-danger rounded bg-white file"
        >
          <div class="d-flex align-items-center w-100">
            <b-icon icon="file-earmark-check" font-scale="3" variant="danger"></b-icon>
            <div class="pl-3">
              <p class="mb-1 font-weight-bold">{{ $t(instruction.title) }}</p>
              <p class="mb-0 font-weight-light">{{ $t('instructionsData.description') }}</p>
            </div>
          </div>
        </a>
      </b-col>
    </template>

    <template v-if="instructions.length > 0">
      <b-col cols="12">
        <h5 class="mb-3">{{ $t('instructionsData.block_title_testy') }}</h5>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-for="instruction in [...instructions.slice(9, 10), ...instructions.slice(11, 12) ]"
             :key="instruction.name">
        <a :href="`/instructions/${encodeURIComponent($t(instruction.link))}`"
           :download="$t(instruction.link)"
           class="d-block mb-3 p-2 border border-danger rounded bg-white file"
        >
          <div class="d-flex align-items-center w-100">
            <b-icon icon="file-earmark-check" font-scale="3" variant="danger"></b-icon>
            <div class="pl-3">
              <p class="mb-1 font-weight-bold">{{ $t(instruction.title) }}</p>
              <p class="mb-0 font-weight-light">{{ $t('instructionsData.description') }}</p>
            </div>
          </div>
        </a>
      </b-col>
    </template>
  </b-row>
</template>

<script>
export default {
  name: "Instruction",
  data() {
    return {
      instructions: [
        {
          name: 'MultiTank',
          title: 'instructionsData.multi',
          link: 'instructionsData.link.multi'
        },
        {
          name: 'Recorder',
          title: 'instructionsData.recorder',
          link: 'instructionsData.link.recorder'
        },
        {
          name: 'Crash',
          title: 'instructionsData.test',
          link: 'instructionsData.link.test'
        },
        {
          name: 'Conservation',
          title: 'instructionsData.conservation',
          link: 'instructionsData.link.conservation'
        },
        {
          name: 'Ftth',
          title: 'instructionsData.ftth',
          link: 'instructionsData.link.ftth'
        },
        {
          name: 'MicroTyphoon',
          title: 'instructionsData.microTyphoon',
          link: 'instructionsData.link.microTyphoon'
        },
        {
          name: 'Typhoon32',
          title: 'instructionsData.typhoon32',
          link: 'instructionsData.link.typhoon32'
        },
        {
          name: 'Typhoon50',
          title: 'instructionsData.typhoon50',
          link: 'instructionsData.link.typhoon50'
        },
        {
          name: 'Y2',
          title: 'instructionsData.connector',
          link: 'instructionsData.link.connector'
        }, {
          name: 'Test micro',
          title: 'instructionsData.test_micro',
          link: 'instructionsData.link.test_micro'
        },
        {
          name: 'Ftth Crash Test',
          title: 'instructionsData.ftth_test',
          link: 'instructionsData.link.ftth_test'
        },{
          name: 'Test HDPE',
          title: 'instructionsData.test_hdpe',
          link: 'instructionsData.link.test_hdpe'
        },
        {
          name: 'Replacement MultiTank Belts',
          title: 'instructionsData.replacement_belts_multitank',
          link: 'instructionsData.link.replacement_belts_link'
        },

      ]
    }
  }
}
</script>

<style scoped lang="scss">
.file {
  transition: box-shadow 0.5s;
  &:hover {
    -webkit-box-shadow: 0 0 6px -2px rgba(66, 68, 90, 0.43);
    -moz-box-shadow: 0 0 6px -2px rgba(66, 68, 90, 0.43);
    box-shadow: 0 0 6px -2px rgba(66, 68, 90, 0.43);
  }
  p{
    font: 300 clamp(.875rem, 1.5vw, 1rem)/1.2rem Lato;
    letter-spacing: 1px;
  }
}
</style>